import { Component } from '@angular/core';

@Component({
  selector: 'app-info-security',
  templateUrl: './info-security.component.html',
  styleUrls: ['./info-security.component.scss']
})
export class InfoSecurityComponent {

}
